import React from "react";
import {Box, Divider, Link, Typography} from "@mui/material";

export default function Footer() {
    return <div>
        <Divider>
            <Typography variant="h6">&copy; Midgard Soura (MiD//RA) 2023</Typography>
        </Divider>
        <Typography variant="body2" align="center">Background: Photo by Anthony Macajone from&nbsp;
            <Link href="https://www.pexels.com/photo/time-lapse-photography-of-road-1782407/">Pexels</Link>
        </Typography>
    </div>
}